import Vue from 'vue';
import previewImgs from './previewImgs.vue';
import CustomImageViewer from './CustomImageViewer.vue';

// 默认图片预览组件
export default {
  install: function install(vue) {
    var PreviewConstructor = vue.extend(previewImgs);
    var instance = new PreviewConstructor();
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);
    Vue.prototype.$previewImg = function (imageList) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var tips = arguments.length > 2 ? arguments[2] : undefined;
      instance.imageList = imageList;
      instance.index = index;
      instance.tips = tips;
      instance.open();
    };
  }
};

// 自定义图片预览组件（无工具栏）
export var SimpleImageViewer = CustomImageViewer;